module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loader-outer"
    }
  }, [_c('ring-loader', {
    attrs: {
      "size": '150px'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loading-text"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "33px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "size": '10px'
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1cc087c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/Loader.vue
// module id = 2270
// module chunks = 1